import { useRef } from "react";
import { generateUuid } from "../utils/utils";

export const useUniqueWcagValues = () => {
  const cacheRef = useRef<Record<string, string>>({});

  const getUniqueValue = (name: string) => {
    if (!cacheRef.current[name]) {
      cacheRef.current[name] = name ? `${name}-${generateUuid()}` : generateUuid();
    }
    return cacheRef.current[name];
  };

  return { getUniqueValue };
};
